<template>
    <bottom-sheet v-model="shows" fullscreen persistent width="1224" maxWidth="100%">
        <template #activator="bind">
            <slot name="activator" v-bind="bind" />
        </template>
        <v-layout column justify-center class="bottom-sheet__contents h-100">
            <v-sheet style="flex: 1 1 auto; overflow-x: hidden; overflow-y: auto" class="scroll-primary pr-10">
                <vertical-form-table v-model="form" v-bind="{ items }"> 

                    <!--서명 완료 전-->
                    <template slot="계약서 서식" v-if="!value.signedForm">
                        <employment-person-pdf-page  v-for="page in value.form.pages" :key="page.page" :value="{ ...value.form, page}" @update="update"/>
                    </template>

                    <!--서명 완료 후-->
                    <template slot="계약서 서식" v-else>
                        <div ref="pdfArea" class="mt-12">
                            <!-- vuetify pdf 적용 (v-app 필요) -->
                            <v-app>
                                <employment-signed-page  v-for="page in value.form.pages" :key="page.page" :value="{ ...value.signedForm, page}"/>
                            </v-app>
                            <v-row justify="end">
                                <v-col cols="auto">
                                    <v-btn small dark color="grey-d" outlined class="w-md-160px" @click="htmlToPdf">
                                        <span class="grey--text">PDF 다운로드</span> <v-icon size="18" color="grey" class="ml-4">mdi-tray-arrow-down</v-icon>
                                    </v-btn>
                                </v-col>
                            </v-row>
                        </div>

                    </template>
                </vertical-form-table>
            </v-sheet>
            <div class="v-btn-group flex-wrap">
                <v-btn outlined color="grey-d" class="min-w-140px min-w-lg-160px" @click="shows = false"><span class="grey-6--text">취소</span></v-btn>
                <v-btn color="primary" class="min-w-140px min-w-lg-160px" v-if="!value.signedForm" @click="save"><span>서명하기</span></v-btn>
                <v-btn color="primary" class="min-w-140px min-w-lg-160px" v-else @click="save"><span>수정하기</span></v-btn>
            </div>
            <v-fade-transition>
                <v-overlay v-show="loading" color="white">
                    <v-progress-circular size="100" width="5" color="primary" indeterminate />
                </v-overlay>
            </v-fade-transition>
        </v-layout>
    </bottom-sheet>
</template>

<script>
import html2Pdf from "html2pdf.js";

import api from '@/api';
import { attrs_input } from "@/assets/variables";

import BottomSheet from "@/components/dumb/bottom-sheet.vue";
import VerticalFormTable from "@/components/dumb/vertical-form-table.vue";
import EmploymentPersonPdfPage from './employment-person-pdf-page.vue';
import EmploymentSignedPage from './signed/employment-signed-page.vue';

const items = [
    {
        key: "",
        term: "계약서 서식",
    },
    {
        key: "identityCard",
        term: "신분증사본",
        type: "file",
        placeholder: "신분증 사본을  업로드해주세요.",
        required: true,
    },
    {
        key: "bankbook",
        term: "통장사본",
        type: "file",
        placeholder: "통장 사본을  업로드해주세요.",
        required: true,
    },
].map((item) => ({ ...attrs_input, ...item }));

export default {
    components: {
        BottomSheet,
        VerticalFormTable,
        EmploymentPersonPdfPage,
        EmploymentSignedPage
    },
    props: {
        value: { type: Object, default: ()=>({}) }
    },
    data: () => ({
        loading: false,
        items,
        shows: false,
        fields: [],
        form: {}
    }),
    mounted(){
        if(this.value.signedForm){
            this.getSignedFiles();
        }else{
            this.syncField();
        }
    },
    methods:{
        update(value){
            const idx = this.fields.findIndex((field)=> field.dataLabel === value.dataLabel);
            if(idx === -1){
                this.fields.push(value);
            } else{
                this.fields[idx] = value;
            }
        },
        syncField(){
            for(let field of this.value.form.fields){
                this.fields.push(field);
            }
        },
        async save(){
            if(this.validation()){
                if(confirm("서명 완료 시, 첨부파일을 제외한 내용은 수정 불가합니다.\n서명하시겠습니까?")){
                    let _signForm = "";

                    this.loading = true;
                    
                    if(this.value.signedForm){
                        _signForm = this.value.signedForm._id;

                    } else{
                        this.formatForm();
                        
                        const { signForm } = await api.v1.person.employment.contracts.post(this.form);

                        _signForm = signForm._id;
                    }
    
                    await Promise.all([
                            api.v1.person.employment.contracts.upload.post({ _signForm, type: "bankbook" }, this.form.bankbook),
                        api.v1.person.employment.contracts.upload.post({ _signForm, type: "identityCard"}, this.form.identityCard)
                    ])

                    this.loading= false;
                    this.shows= false;
                }
            }

        },
        formatForm(){
            let value = this.value;
            let form = this.form;

            form._company = value._company;
            form._form = value._form;
            form._contract = value._id;
            form.fields = this.fields;
        },
        async getSignedFiles(){
            const bankbook = await api.getResource(this.value.signedForm.bankbook, true);
            const identityCard = await api.getResource(this.value.signedForm.identityCard, true);

            this.form.bankbook = bankbook;
            this.form.identityCard = identityCard;
        },
        htmlToPdf(){
            const options = {
                    html2canvas: { scale: 2 },
                    filename: this.value.form.name + ".pdf",
                    jsPDF: { orientation: 'portrait', unit: 'px', format: [974,1379], compressPDF: true },
                    // jsPDF: { orientation: 'portrait', unit: 'px', format: [974,689], compressPDF: true },
                    margin: [0, 0, 0, 0], 
                    pagebreak: { mode: ['css'], before:"pdfImg" }
                    // maxPages: 3, // 최대 페이지 수
            };
            html2Pdf().set(options).from(this.$refs.pdfArea).save();
        },
        validation(){
            const emptyFields = this.fields.filter((field)=> (field?.type === "text-employee" || field?.type === "canvas") && !field?.content);

            if(emptyFields.length > 0){
                alert (`입력되지 않은 필드가 ${emptyFields.length}개 있습니다.`);
            } else if( !this.form.identityCard || !this.form.bankbook){
                alert("신분증 사본과 통장 사본을 업로드해주세요.");
            } else{
                return true;
            }
        }
    },
    watch:{
        shows(){
            this.$emit('show');
        }
    },
};
</script>

<style lang="scss" scoped>
</style>
